import React from "react";
export default function Portfolio() {
  return (
    <>
      <div className="portfolio">
        <div className="portfolio-grid" data-aos="fade-up">
          <img
            src="https://tse1.mm.bing.net/th?id=OIP.sjVpTjZa7Iyt2bbek8ptgAHaEK&pid=Api&P=0&h=180"
            alt="img1"
          />
          <img
            src="https://tse2.mm.bing.net/th?id=OIP.v-lgiB0mnPbKEh7AT_m96gHaEK&pid=Api&P=0&h=180"
            alt="img2"
          />
          <img
            src="https://tse2.mm.bing.net/th?id=OIP.UtGvZJHUxOf0Sl3Lfu2r-AHaEL&pid=Api&P=0&h=180"
            alt="img3"
          />
          <img
            src="https://tse4.mm.bing.net/th?id=OIP.UdHMpIRgPRqb_ZkOE0NHDAHaEK&pid=Api&P=0&h=180"
            alt="img4"
          />
          <img
            src="https://th.bing.com/th/id/OIP.6AwfvMS9Z_ujYPRtHs1fYgHaFb?w=224&h=180&c=7&r=0&o=7&dpr=1.3&pid=1.7&rm=3"
            alt="img5"
          />
          <img
            src="https://tse1.mm.bing.net/th?id=OIP.Dzll38Pig8XqAcFje9KSrAHaEK&pid=Api&P=0&h=180"
            alt="img6"
          />
        </div>
      </div>
    </>
  );
}
